module.exports = "img/cancel-small.495f44c.svg";